const SORTED_IMAGE_LABELS = [
  "Raw frontal",
  "Enhanced Front",
  "Raw Profile",
  "Enhanced profile",
  "Future without treatment",
  "Future with treatment",
  "Enhanced Lash Brow",
  "Wellness Body",
  "Wellness weightloss",
  "Wellness muscle gain",
  "Wellness combined",
];

const toWords = (value) =>
  String(value || "")
    .trim()
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean);

const toNativeCamelCase = (value) =>
  toWords(value)
    .map((word, index) => {
      const normalizedWord = word.toLowerCase();

      if (index === 0) {
        return normalizedWord;
      }

      return `${normalizedWord.charAt(0).toUpperCase()}${normalizedWord.slice(
        1,
      )}`;
    })
    .join("");

const normalizeImageType = (imageType) =>
  String(imageType || "")
    .toLowerCase()
    .replace(/self/g, "")
    .replace(/[^a-z0-9]/g, "");

const IMAGE_SORT_ORDER = SORTED_IMAGE_LABELS.reduce((order, label, index) => {
  order[toNativeCamelCase(label).toLowerCase()] = index;
  order[normalizeImageType(label)] = index;
  return order;
}, {});

const getDefinedRank = (rank) =>
  typeof rank === "number" ? rank : SORTED_IMAGE_LABELS.length;

const getImageSortRank = (imageType) => {
  const camelCaseRank =
    IMAGE_SORT_ORDER[toNativeCamelCase(imageType).toLowerCase()];

  if (typeof camelCaseRank === "number") {
    return camelCaseRank;
  }

  return getDefinedRank(IMAGE_SORT_ORDER[normalizeImageType(imageType)]);
};

export const getAgelessImageTranslationKey = (imageType) =>
  `leadsImages.${toNativeCamelCase(imageType)}`;

export const sortAgelessImages = (images = []) =>
  images
    .map((image, index) => ({ image, index }))
    .sort((firstImage, secondImage) => {
      const firstImageType = firstImage.image && firstImage.image.imageType;
      const secondImageType = secondImage.image && secondImage.image.imageType;
      const rankDiff =
        getImageSortRank(firstImageType) - getImageSortRank(secondImageType);

      return rankDiff || firstImage.index - secondImage.index;
    })
    .map(({ image }) => image);
